export enum EApiStatus {
  LOADING,
  SUCCESS,
  ERROR,
}
